/** Indicates whether the current URL is in the restricted area.
 * @param {URL} currentUrl
 * @return {boolean}
 */
const getIsRestrictArea = currentUrl => currentUrl?.pathname?.startsWith('/app');

export default getIsRestrictArea;
